import { Pressable } from "react-native";
export const ThemedPressable = ({ style, children, disabled, ...props }) => {
    return (<Pressable style={style} {...props} disabled={disabled}>
      {children}
    </Pressable>);
};
//# sourceMappingURL=ThemedPressable.js.map